
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculator",
      function () {
        return require("private-next-pages/calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculator"])
      });
    }
  